module.exports = "//cdn.mxpnl.com/static/asset-cache/b777fc0ca05e2e22071eaaf47bea8199/iron/common/widgets/warning-hero/images/empty-experiments.svg";